class ScrollService {
    /**
     * Updates the global scroll status.
     *
     * @source Daniel (2024-12-17 07:22)
     * @update Eugeni Ostapko (2025-02-11 18:18)
     */
    init() {
        document.addEventListener("scroll", this.update);
        this.update();
        this.checkForHash();
        this.initPaginationScroll();
    }

    /**
     * Updates the global scroll status.
     *
     * @source Daniel (2024-12-17 07:22)
     * @update Daniel (2025-04-21 21:00)
     */
    update() {
        const position = window.scrollY;

        window.scrolled = position > 5;
        document.documentElement.classList.toggle("scrolled", window.scrolled);

        if (!window.scrolled || typeof window.scrollPosition == "undefined") {
            document.documentElement.classList.toggle("scrolled-up", false);
            document.documentElement.classList.toggle("scrolled-down", false);
            window.scrollPosition = position;
            return;
        }

        document.documentElement.classList.toggle("scrolled-up", position < window.scrollPosition);
        document.documentElement.classList.toggle(
            "scrolled-down",
            position > window.scrollPosition
        );
        document.documentElement.classList.toggle("scrolled-deep", position > 400);
        window.scrollPosition = position;
    }

    // 6fa90455 Eugeni Ostapko (2025-02-11 18:18)
    checkForHash() {
        const _that = this;
        document.addEventListener("DOMContentLoaded", function () {
            if (window.location.hash) {
                _that.scrollToId(window.location.hash.replace("#", ""));
            }
        });
    }

    // 6fa90455 Eugeni Ostapko (2025-02-11 18:18)
    scrollToId(id, event = null) {
        const element = document.getElementById(id);
        if (element) {
            event && event.preventDefault();
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const headerHeight = document.querySelector("header").offsetHeight;
            const offsetPosition = elementPosition - headerHeight - 50;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    }

    initPaginationScroll() {
        document.addEventListener("click", (event) => {
            const link = event.target.closest(".woocommerce-pagination a");

            if (!link) {
                return;
            }

            const element = document.getElementById("kd-products-list");

            if (!element) {
                return;
            }

            const header = document.querySelector("header");
            const headerHeight = header ? header.offsetHeight : 0;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerHeight - 150;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        });
    }
}

export default ScrollService;
